<template>
  <div class="edit-detail">
    <div style="width: 100vw;margin-left: -.4rem;background: #ffffff;padding: .4rem">
      <van-nav-bar
        :title="`${staffName}的月报`"
        left-arrow
        @click-left="onClickLeft"
      />
      <div class="edit-date">
        <span>日期：{{reportDate}}</span>
        <a @click="handleJump">当月日报</a>
      </div>
    </div>
    <div class="task-span">
      <span class="edit-label">任务打分</span>
      <span class="edit-label">自评得分：{{selfScore}}</span>
      <span class="edit-label">领导评分：{{leadScore}}</span>
    </div>
    <div>
      <a-collapse v-model="activeKey1" expand-icon-position="right">
        <a-collapse-panel v-for="(item, index) in taskData1" :key="index" :header="item ? `岗位：${item.postName}` : ''" >
          <div v-for="(i, index1) in item.sysStaffReportTaskList" :key="index1">
            <div>岗位职责：{{i.dutyDesc}}</div>
            <div>任务名称：{{i.taskName}}</div>
            <div>任务权重：{{i.weight}}%</div>
            <div>任务自评：{{i.selfComment}}</div>
            <span>领导评分：</span><a-input-number v-if="status !=2" v-model="i.leadComment" :min="0" :max="100"/>
            <span v-else>{{i.leadComment}}</span>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <span class="edit-label">工作汇报</span>
    <div class="edit-workReport">
      <a-textarea v-model="content" disabled class="ant-textarea" />
    </div>
    <div class="edit-label">附件</div>
    <div class="annex" v-for="(item,index) in resourcesList" :key="index">
      <div>
        <img style="width: 24px;height: 21px" src="../assets/file@2x.png" />
        <span>{{item.name}}{{item.suffix}}</span>
      </div>
      <van-button @click="preview(item.url)" type="primary">预览</van-button>
    </div>
    <div class="edit-label">下月规划</div>
    <div>
      <a-collapse v-model="activeKey2" expand-icon-position="right">
        <a-collapse-panel v-for="(item, index) in taskData2" :key="index" :header="item ? `岗位：${item.postName}` : ''" >
          <div v-for="(i, index1) in item.sysStaffReportTaskList" :key="index1">
            <div>岗位职责：{{i.dutyDesc}}</div>
            <div>任务名称：{{i.taskName}}</div>
            <div>任务权重：{{i.weight}}%</div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <div v-if="status != 2 && conditionType == 2" class="edit-submit1" @click="handleSubmit">提交</div>
    <div v-if="status != 2 && conditionType == 2" class="edit-submit2" @click="submitAndOne">提交并审核下一个</div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import { getMonthReportDetail, handleGrade } from '../axios/services' 
import { mapState } from 'vuex'
export default {
  data() {
    return {
      taskData1: [],
      taskData2: [],
      reportId: '',
      activeKey1: '',
      activeKey2: '',
      resourcesList: [],
      status: '',
      content: '',
      selfScore: '',
      leadScore: ''
    };
  },
  watch: {
    taskData1: {
      handler(newValue, oldValue) {
        let count1 = 0
        let count2 = 0
        this.slefScore = newValue.forEach(item => {
          if(item.duties) {
            item.duties.forEach(i => {
              let m = i.selfComment || ''
              let n = i.weight || ''
              let o = i.leadComment || ''
              if(m && n) count1 += i.selfComment * i.weight * 0.01
              if(n && o) count2 += i.leadComment * i.weight * 0.01
            })
          }
          if(item.sysStaffReportTaskList) {
            item.sysStaffReportTaskList.forEach(i => {
              let m = i.selfComment || ''
              let n = i.weight || ''
              let o = i.leadComment || ''
              if(m && n) count1 += i.selfComment * i.weight * 0.01
              if(n && o) count2 += i.leadComment * i.weight * 0.01
            })
          }
        })
        this.selfScore = count1
        this.leadScore = count2
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['conditionType'])
  },
  methods: {
    onClickLeft() {
      window.history.go(-1)
    },
    handleSubmit() {
      let params = []
      let flag = false
      this.taskData1.forEach(item => {
        if(item.sysStaffReportTaskList && item.sysStaffReportTaskList.length > 0) {
          params = params.concat(item.sysStaffReportTaskList)
        }
      });
      params.forEach(item => {
        if(!item.leadComment) {
          flag = true
        }
      })
      if(flag) return Toast('没填写评分分数')
      params = params.map(item => ({...item, status: '2'}))
      handleGrade(params).then(res => {
        if(res.data.code === 0) {
          this.$router.push('/month-report')
        }else {
          Toast.fail(res.data.msg)
        }
      })
    },
    submitAndOne() {
      let params = []
      let flag = false
      this.taskData1.forEach(item => {
        if(item.sysStaffReportTaskList && item.sysStaffReportTaskList.length > 0) {
          params = params.concat(item.sysStaffReportTaskList)
        }
      });
      params.forEach(item => {
        if(!item.leadComment) {
          flag = true
        }
      })
      if(flag) return Toast('没填写评分分数')
      params = params.map(item => ({...item, status: '2'}))
      handleGrade(params).then(res => {
        if(res.data.code === 0) {
          if(res.data.data) {
            this.$router.push(`/month-report-detail/${res.data.data}`)
            const param = {
              reportId: res.data.data
            }
            getMonthReportDetail(param).then(res => {
              if(res.data.code === 0) {
                this.taskData1 = res.data.data.currentMonth.sysStaffReportTaskQueryVoList
                this.taskData2 = res.data.data.nextMonth.sysStaffReportTaskQueryVoList
                this.resourcesList = res.data.data.currentMonth.resourcesList
                this.reportDate = res.data.data.currentMonth.reportDate
                this.staffName = res.data.data.currentMonth.staffName
                this.status = res.data.data.currentMonth.status
                this.content = res.data.data.currentMonth.content
              }else {
                Toast.fail(res.data.msg)
              }
            })
          }else{
            Toast('已审核完')
          }
        }
        if(res.data.code !== 0) {
          Toast.fail(res.data.msg)
        }
      })
    },
    preview(param) {
      window.location.href = "jsToOc://fujianJump?url=" + param
    },
    handleJump() {
      this.$router.push('/daily')
    }
  },
  created() {
    this.reportId = this.$route.params.id
    const params = {
      reportId: this.reportId
    }
    getMonthReportDetail(params).then(res => {
      if(res.data.code === 0) {
        this.taskData1 = res.data.data.currentMonth.sysStaffReportTaskQueryVoList
        this.taskData2 = res.data.data.nextMonth?.sysStaffReportTaskQueryVoList
        this.resourcesList = res.data.data.currentMonth.resourcesList
        this.reportDate = res.data.data.currentMonth.reportDate
        this.staffName = res.data.data.currentMonth.staffName
        this.status = res.data.data.currentMonth.status
        this.content = res.data.data.currentMonth.content
      }else {
        Toast.fail(res.data.msg)
      }
    })
  }
};
</script>
<style scoped>
  .edit-detail {
    width: 100%;
    background: #f9f9f9;
    min-height: 100vh;
    padding: 0 .4rem;
  }
  .edit-detail /deep/ .van-nav-bar {
    background: none;
  }
  .van-hairline--bottom::after {
    border: none;
  }
  .van-nav-bar /deep/ .van-nav-bar__left {
    padding: 0 !important;
  }
  .van-nav-bar /deep/ .van-nav-bar__arrow {
    font-size: 24px !important;
    color: black;
  }
  .edit-date {
    height: 1rem;
    display: flex;
    justify-content: space-between;
  }
  .task-span {
    display: flex;
    justify-content: space-between;
    margin-top: .4rem;
  }
  .edit-label {
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
    font-size: .4rem;
  }
  .ant-collapse-item /deep/.ant-collapse-header {
    width: 100%;
    height: 1rem;
    padding: .2rem !important;
    color: inherit;
    background-color: #ffffff;
    border-radius: 4px !important;
  }
  .ant-collapse {
    background: none !important;
    overflow: hidden;
    margin-top: .2rem;
    margin-bottom: .2rem;
  }
  /* .ant-collapse-item /deep/ .ant-collapse-content {
    background-color: #F2F2F2 !important;
  } */
  .ant-collapse-item /deep/ .ant-collapse-content-box {
    padding: 10px !important;
  }
  .ant-textarea {
    min-height: 4rem;
    margin-top: .2rem;
    margin-bottom: .2rem;
  }
  .ant-input-number {
    width: 60%;
    margin-bottom: .2rem;
  }
  .annex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
  }
  .van-button {
    height: 1rem;
    margin: .3rem .5rem;
  }
  .edit-submit1{
    width: 93%;
    height: 1rem;
    border-radius: .1rem;
    color: white;
    line-height: 1rem;
    text-align: center;
    margin: .5rem auto;
    background: #1584ff;
    border-radius: 8px;
    box-shadow: 0px 2px 8px 0px #80bcff; 
    /* position:absolute;
    bottom: 68px;
    left: 12px; */
  }
  .edit-submit2{
    width: 93%;
    height: 1rem;
    border-radius: .1rem;
    line-height: 1rem;
    text-align: center;
    margin: 0 auto;
    /* position:absolute; */
    border: 1px solid #ccc;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    color: #1584ff;
    /* bottom: 20px;
    left: 12px; */
  }
</style>
